export const CREATE_RATING_SUCCESS = 'CREATE_RATING_SUCCESS';